// เกมที่ไม่ต้องการให้แสดงใน dashboard / sidebar (แม้จะมีใน gameconfig API)
// เพิ่ม/ลบ code ที่นี่ที่เดียว มีผลทั้ง sidebar และตารางรายเกมใน Dashboard
export const HIDDEN_GAME_CODES = ["G056"];
